import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/utils/redux/store';
import { StorageEnum } from '~/utils/enum/base';
import { createNewPassword, forgotPassword, handleLogin, verifyCode } from './authThunk';

export interface AuthState {
  accessToken?: string;
}

const initialState: AuthState = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout(state) {
      localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
      state.accessToken = undefined;
    },
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
  },
  extraReducers(builder) {
    // POST: login
    builder
      .addCase(handleLogin.pending, (_state) => {})
      .addCase(handleLogin.fulfilled, (_state) => {})
      .addCase(handleLogin.rejected, (_state) => {});

    // POST: forgot password
    builder
      .addCase(forgotPassword.pending, (_state) => {})
      .addCase(forgotPassword.fulfilled, (_state) => {})
      .addCase(forgotPassword.rejected, (_state) => {});

    // POST: verify code
    builder
      .addCase(verifyCode.pending, (_state) => {})
      .addCase(verifyCode.fulfilled, (_state) => {})
      .addCase(verifyCode.rejected, (_state) => {});

    // POST: new password
    builder
      .addCase(createNewPassword.pending, (_state) => {})
      .addCase(createNewPassword.fulfilled, (_state) => {})
      .addCase(createNewPassword.rejected, (_state) => {});
  },
});

export const authActions = authSlice.actions;

export const selectAccessToken = (state: RootState) => state.auth.accessToken;

const authReducer = authSlice.reducer;
export default authReducer;
